/**
 * The one message the portal shows when it cannot reach the backend (PP-028 / proweb-74 AC-001).
 *
 * Standardised deliberately: before this, each section said the same thing in its own words, and none
 * of them told the provider what to do about it. The wording below is the approved copy and is
 * reproduced verbatim — do not rephrase it.
 *
 * In `components/shared` rather than `components/layout` because the login screen renders outside the
 * app shell, and a feature may not import from layout.
 */
export const SERVICE_UNAVAILABLE_TITLE = 'Service Temporarily Unavailable';

export const SERVICE_UNAVAILABLE_BODY =
  'We are currently experiencing a temporary issue that is affecting system connectivity. ' +
  'Please try again in a few minutes. If the problem persists, contact Customer Support for ' +
  'assistance. We apologize for any inconvenience and appreciate your patience.';

export function ServiceUnavailableBanner(): React.JSX.Element {
  return (
    <div
      role="alert"
      className="border-destructive/40 bg-destructive/10 text-destructive rounded-xl border px-6 py-4"
    >
      <p className="text-sm font-semibold">
        <span aria-hidden="true">⚠️ </span>
        {SERVICE_UNAVAILABLE_TITLE}
      </p>
      <p className="mt-1 text-sm">{SERVICE_UNAVAILABLE_BODY}</p>
    </div>
  );
}
